import NotificationsProvider from '@/providers/NotificationsProvider'

var NotificationsService = function (email, assetIds) {
  return {
    async postNotifications (email, assetIds) {
      return NotificationsProvider.postNotifications(email, assetIds)
    }
  }
}

export default new NotificationsService()



// WEBPACK FOOTER //
// ./src/services/r8/NotificationsService.js